import type { About, Site, Project, Repository } from './types';

export const about: About = {
  name: 'Hajin',
  role: ['Full-Stack Developer', 'Software Engineer', 'UI/UX Enthusiast'],
  status: 'University Student & Software Developer',
  languages: ['Korean', 'English', 'Urdu'],
  skills: ['React', 'TypeScript', 'Node.js', 'Python', 'C / C++', 'Java', 'Databases', 'Vibe Coding'],
  interests: ['System Architecture', 'Open Source', 'Web Performance']
};

export const sites: Site[] = [
  {
    "id": "1775836013220",
    "title": "flow",
    "subtitle": "typing platform",
    "description": "Master your typing across languages and code",
    "url": "https://flow.hajin.tech"
  },
  {
    "id": "1775836962882",
    "title": "pallet",
    "subtitle": "color pallet generator",
    "description": "This is a modern web application for generating color palettes and AI-ready design prompts.",
    "url": "https://pallet.hajin.tech/"
  },
  {
    "id": "1775837520020",
    "title": "VIBE CAMP",
    "subtitle": "Community Platform",
    "description": "A modern community platform for connecting and sharing experiences.",
    "url": "https://vibe-camp.hajin.tech"
  }
];

export const projects: Project[] = [
  {
    "id": "portfolio",
    "title": "PORTFOLIO",
    "subtitle": "Personal Website",
    "description": "Minimalist portfolio with Nothing-inspired design.",
    "tags": [
      "React",
      "TypeScript",
      "Vite"
    ]
  },
  {
    "id": "cli-tools",
    "title": "CLI TOOLS",
    "subtitle": "Command Line",
    "description": "Collection of useful command-line utilities.",
    "tags": [
      "Python",
      "Bash"
    ]
  }
];

export const MAX_REPOS = 6;

export const customRepos: Repository[] = [
  {
    "id": 1775837076589,
    "name": "pallett",
    "description": "This is a modern web application for generating color palettes and AI-ready design prompts.",
    "html_url": "https://github.com/husky-696/pallett",
    "language": "TypeScript",
    "stargazers_count": 0,
    "forks_count": 0,
    "fork": false,
    "topics": []
  }
];
